module.exports = require('./helpers/bundle-url').getBundleURL('sif1r') + "discord.e271280c.svg";